
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Point, Size, Rectangle } from "../../../domain/drawing";
import { AsyncRequestPool } from "../../../utilities";
import { MouseTrackableMixin } from ".";

@Component({
})
export default class LocatableMixin extends Mixins(MouseTrackableMixin) {
  data(): any {
    return {
      locatorRequestPool: new AsyncRequestPool<Rectangle, { toRectangle: () => Rectangle, result: Rectangle }>(),
    };
  }
  locatorRequestPool: AsyncRequestPool<Rectangle, { toRectangle: () => Rectangle, result: Rectangle }>;

  get isLocating(): boolean {
    return this.locatorRequestPool.isProcessing
      && !this.locatorRequestPool.processingRequest.source.result;
  }

  get locatorRectangle(): Rectangle {
    return this.isLocatorVisible
      ? this.locatorRequestPool.processingRequest.source.toRectangle()
      : new Rectangle();
  }

  get isLocatorVisible(): boolean {
    return this.isLocating
      && this.isMouseTracking;
  }

  @Watch("isMouseLeftButtonPressed")
  onMouseLeftButtonClickedForLocator(newValue: boolean, oldValue: boolean) {
    if (newValue && this.isLocatorVisible) {
      this.locatorRequestPool.processingRequest.source.result = this.locatorRequestPool.processingRequest.source.toRectangle();
    }
  }

  async locate(size: Size): Promise<Point> {
    const result = await this._locate(
      () => new Rectangle(
        this.mouseLocation,
        size
      )
    );
    return !result
      ? null
      : result.topLeft;
  }

  protected async _locateVertically(rectangle: Rectangle): Promise<Point> {
    const result = await this._locate(
      () => new Rectangle(
        new Point(rectangle.x, this.mouseLocation.y),
        rectangle.size.clone())
    );
    return !result
        ? null
        : result.topLeft;
  }

  private async _locate(getLocatorRectangle: () => Rectangle): Promise<Rectangle> {
    if (!getLocatorRectangle) {
      throw new Error("ロケータ矩形取得ハンドラが指定されていません.実装を確認してください.");
    }
    return this.locatorRequestPool.request(
      {
        toRectangle: getLocatorRectangle,
        result: null,
      },
      this,
      async (source: { toRectangle: () => Rectangle, result: Rectangle }) => {
        await this.$wait(() => !this.isLocating);
        return source.result;
      }
    );
  }

  cancelLocating(): void {
    this.locatorRequestPool.cancel(this);
  }
}
